'use client';

import { BlenderEvents, trackTagManagerEvent } from 'firebase-client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Sidebar as UiSidebar } from 'ui';
import { useResolution } from 'ui/hooks';

import { useNavigationOptions } from '~/data';
import { convertHrefToEventKey } from '~/utils';

import { DesktopHeader } from './DesktopHeader';
import { MobileHeader } from './MobileHeader';

interface Props {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
}

const Sidebar = ({ isSidebarOpen, toggleSidebar }: Props) => {
  const pathname = usePathname();
  const { isDesktop, isTablet } = useResolution();
  const navigationOptions = useNavigationOptions();

  return (
    <UiSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}>
      {isDesktop || isTablet ? (
        <DesktopHeader isSidebarOpen={isSidebarOpen} />
      ) : (
        <MobileHeader toggleSidebar={toggleSidebar} />
      )}

      <UiSidebar.Menu>
        {navigationOptions.map(({ label, href, icon }, i) => {
          const eventKey = convertHrefToEventKey(href);
          return (
            <UiSidebar.Item
              key={i}
              data-testid={`sidebar-item-${href.slice(1)}`}
              component={Link}
              href={href}
              icon={icon}
              onClick={() => trackTagManagerEvent(BlenderEvents[eventKey as keyof typeof BlenderEvents])}
              selected={pathname === href}
            >
              {label}
            </UiSidebar.Item>
          );
        })}
      </UiSidebar.Menu>
    </UiSidebar>
  );
};

export default Sidebar;
